<template>
      <v-container class="grey lighten-5">
      <v-row
        no-gutters
        style="height: 150px;"
      >
        <v-col
        >
          <v-card
            class="pa-2 ma-3"
            outlined
            tile
          >

 
          <h1>DELETE KIOSK</h1>
        <v-text-field label="kioskName" v-model="deletingKiosk"></v-text-field>
        <v-btn color="error" @click="deleteKiosk"> DELETE</v-btn>

            <v-snackbar
      v-model="snackbar"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>


        
       
</v-card >
        </v-col>
      </v-row>
      </v-container>
</template>

<script>

import {deleteKiosk} from "@/services/RequestService";

export default {
    data:()=>{
        return{
            deletingKiosk:null,
            text:"INIT TEXT",
            snackbar: false,
        }
    }, 

    methods:{
       async deleteKiosk(){
            this.text = await deleteKiosk(this.deletingKiosk);
            this.snackbar=true;
        }
    }
}
</script>

<style>

</style>